import {
  Box,
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useReconcileContext } from "../reconcile.context";

export default function ReconcileForm({
  row,
  data,
  handleClose,
  onChange,
  onSubmit,
}) {
  const { companyVendors } = useReconcileContext();

  return (
    <>
      <Typography variant="h6" component="h2" sx={{ fontWeight: "bold" }}>
        Reconcile Material with new PO :
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            autoComplete="off"
            onChange={onChange}
            name="poNumber"
            label="PO #"
            value={data.poNumber}
            fullWidth
            sx={{ m: 0.5 }}
          />
          <TextField
            autoComplete="off"
            onChange={onChange}
            name="poDate"
            fullWidth
            type="date"
            value={data.poDate}
            sx={{ m: 0.5 }}
          />

          <Select
            value={data.vendor?.name}
            name="vendor"
            onChange={onChange}
            fullWidth
            sx={{ m: 0.5 }}
          >
            {companyVendors.map((v) => {
              return (
                <MenuItem value={v} key={v.id}>
                  {v.name}
                </MenuItem>
              );
            })}
          </Select>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="h6" component="h2" sx={{ fontWeight: "bold" }}>
            Material :
          </Typography>
          <TextField
            disabled
            value={data.description}
            sx={{ m: 0.5 }}
            fullWidth
          />

          <TextField
            autoComplete="off"
            onChange={onChange}
            name="quantity"
            label={"Required Quantity (" + row.unit + ")"}
            value={data.quantity}
            sx={{ m: 0.5, mt: 1.5 }}
            fullWidth
            type="number"
          />
        </Grid>
      </Grid>

      <Box sx={{ textAlign: "right", my: 1 }}>
        <Button variant="outlined" onClick={handleClose}>
          close
        </Button>
        <Button onClick={onSubmit} variant="contained" sx={{ ml: 1 }}>
          Create New PO
        </Button>
      </Box>
    </>
  );
}
